import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import Api from "../../api/Api";
import fileDownload from "js-file-download";
import PropTypes from "prop-types";
import React from "react";
import Split from "../shared/Split";

const UserReportsModal = ({ isOpen = false, toggle }) => {
  const userReport = () =>
    Api({
      method: "GET",
      url: "user-report",
      responseType: "blob",
    }).then((response) => {
      const date = new Date();
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = (date.getDate()).toString().padStart(2, '0');
      fileDownload(
        response.data,
        `UsersReport-${`${year}-${month}-${day}`}.csv`
      );
    });

  return (
    <Modal centered isOpen={isOpen} toggle={toggle}>
      <ModalHeader>User Reports</ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            <Split>
              <div>
                <h5>Users Report</h5>
                <p>
                  CSV of all users.
                </p>
              </div>
              <div>
                <Button
                  className="btn-cp-secondary"
                  onClick={userReport}>
                  Generate
                </Button>
              </div>
            </Split>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button className="btn-cp" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

UserReportsModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
};

export default UserReportsModal;
